<ul class="flex items-center">
  @for (social of socials; track $index) {
  <li>
    <a
      [href]="social.link"
      class="s-24 flex justify-center items-center rounded-full"
      target="_blank"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        [src]="social.icon"
      ></svg-icon>
    </a>
  </li>
  }
</ul>
